// cspell:disable
const QATags = Object.freeze({
  AAI: 'album_active_image',
  AAID: 'album_active_image_default',
  AAN: 'aam_artist_name',
  AANL: 'album_artist_name_link',
  ACB: 'aam_cta_button',
  AHAN: 'aam_history_artist_name',
  AHCB: 'aam_history_cta_button',
  AHI: 'album_history_image',
  AHID: 'album_history_image_default',
  AHIFI: 'aam_history_inappropriate_flag_icon',
  AIFI: 'aam_inappropriate_flag_icon',
  AMSL: 'autocomplete_menu_section_link',
  ANL: 'album_name_link',
  AOMB: 'album_open_menu_button',
  ARMCS: 'artist_menu_create_station',
  ARNL: 'artist_name_link',
  AROMB: 'artist_open_menu_button',
  ARTI: 'artist_thumbnail_image',
  ASI: 'autocomplete_search_input',
  ASL: 'add_station_link',
  ASPEO: 'active_station_playing_equalizer_overlay',
  ASPI: 'add_station_plus_icon',
  ASPSEO: 'active_station_paused_equalizer_overlay',
  ASTI: 'add_station_tile_image',
  ATI: 'album_thumbnail_image',
  BAT: 'backstage_album_track',
  BATEQ: 'backstage_album_track_eq',
  BATI: 'backstage_album_track_itunes',
  BATL: 'backstage_album_track_link',
  BB: 'browse_button',
  BGB: 'browse_genres_button',
  BGI: 'backstage_grid_item',
  BGIA: 'backstage_grid_item_art',
  BGIIL: 'backstage_grid_item_itunes_logo',
  BGITF: 'backstage_grid_item_text_first',
  BGITS: 'backstage_grid_item_text_second',
  BGITT: 'backstage_grid_item_text_third',
  BGSMB: 'backstage_grid_show_more_button',
  BGSME: 'backstage_grid_show_more_ellipsis',
  BI: 'birthyear_input',
  BPB: 'browse_podcasts_button',
  BPI: 'backstage_playable_item',
  BPIP: 'backstage_playable_item_play',
  BPRG: 'backstage_playable_row_grid',
  BRAMC: 'button_row_add_to_my_collection',
  BRCS: 'button_row_create_station',
  BRDP: 'button_row_delete_playlist',
  BRDS: 'button_row_delete_station',
  BRELL: 'button_row_ellipsis',
  BRP: 'button_row_play',
  BRPU: 'button_row_pause',
  BRRMC: 'button_row_remove_from_my_collection',
  BRS: 'button_row_share',
  BRSC: 'button_row_sourcecard',
  BS: 'backstage',
  BSAB: 'backstage_artist_buttons',
  BSASS: 'backstage_artist_start_station',
  BSATM: 'backstage_artist_top_songs_mobile_web',
  BSATS: 'backstage_artist_top_songs',
  BSET: 'backstage_editable_title',
  BSH: 'backstage_header',
  BSMB: 'bio_show_more_button',
  BSPA: 'backstage_playlist_author',
  BSPC: 'backstage_playlist_curator',
  BSPTC: 'backstage_playlist_track_count',
  BST: 'backstage_tracks',
  BSTL: 'backstage_twitter_link',
  BT: 'bio_title',
  BTAL: 'backstage_track_artist_link',
  BTLL: 'backstage_track_album_link',
  BTX: 'bio_text',
  BYL: 'birthyear_why_link',
  CANCELP: 'cancel_password',
  CB: 'cancel_button',
  CCEXPMONTH: 'creditcardform_expiration_month',
  CCEXPYEAR: 'creditcardform_expiration_year',
  CCNAME: 'creditcardform_name',
  CCNUMBER: 'creditcardform_number',
  CCSECURITYCODE: 'creditcardform_security_code',
  CCSUBMIT: 'creditcardform_submit',
  CCZIPCODE: 'creditcardform_zipcode',
  CLB: 'close_button',
  CLOADB: 'cancel_log_out_all_devices_button',
  COB: 'continue_button',
  CPXB: 'close_popup_x_button',
  DAB: 'delete_account_button',
  DAC1: 'display_ad_container_1',
  DAC2: 'display_ad_container_2',
  DBL: 'description_backstage_link',
  DBT: 'description_backstage_text',
  DD: 'dropdown',
  DTIT: 'discovery_tuner_introduction_text',
  DTMB: 'discovery_tuner_mode_button',
  DTMBL: 'discovery_tuner_mode_buttons_list',
  DTMBN: 'discovery_tuner_mode_button_name',
  DTMSC: 'discovery_tuner_mode_selection_column',
  ECB: 'email_clear_button',
  EI: 'email_input',
  ET: 'elapsed_time',
  FT: 'focus_traits',
  GCNL: 'genre_category_name_link',
  GCTI: 'genre_category_tile_image',
  GFB: 'gender_female_button',
  GFS: 'gender_female_span',
  GMB: 'gender_male_button',
  GMS: 'gender_male_span',
  GNB: 'gender_non_binary_button',
  GSC: 'genre_stations_count',
  GSLC: 'genre_station_listeners_count',
  GSNL: 'genre_station_name_link',
  GSTI: 'genre_station_tile_image',
  GTCSB: 'go_to_classic_site_button',
  GYL: 'gender_why_link',
  HAA: 'history_artist_name',
  HAEI: 'history_active_equalizer_image',
  HATD: 'history_active_thumbs_down',
  HATU: 'history_active_thumbs_up',
  HHI: 'header_help_icon',
  HIFR: 'history_infocus_replay',
  HIFTD: 'history_infocus_thumbs_down',
  HIFTU: 'history_infocus_thumbs_up',
  HIM: 'history_infocus_image',
  HIMD: 'history_infocus_image_default',
  HIMG: 'history_image',
  HIMGD: 'history_image_default',
  HLB: 'header_login_button',
  HLI: 'human_logo_icon',
  HMDB: 'hover_menu_delete_button',
  HMPB: 'hover_menu_pause_button',
  HMPSB: 'hover_menu_play_station_button',
  HMSB: 'hover_menu_share_button',
  HMSD: 'hover_menu_station_details',
  HMSL: 'header_my_stations_link',
  HNPL: 'header_now_playing_link',
  HOMSB: 'hover_open_menu_station_button',
  HPI: 'header_pandora_image',
  HPOI: 'header_pandoraone_image',
  HPRI: 'header_profile_image',
  HPSB: 'hover_play_station_button',
  HSAABL: 'header_search_autocomplete_artist_backstage_link',
  HSACSL: 'header_search_autocomplete_artist_create_station_link',
  HSATBL: 'header_search_autocomplete_track_backstage_link',
  HSATCSL: 'header_search_autocomplete_track_create_station_link',
  HSATHBL: 'header_search_autocomplete_top_hit_backstage_link',
  HSATPCSL: 'header_search_autocomplete_top_hit_create_station_link',
  HSB: 'header_signup_button',
  HSET: 'header_search_edit_text',
  HSI: 'header_search_icon',
  HSTST: 'header_static_text_subtitle',
  HSTSTL: 'header_static_text_subtitle_link',
  HSTT: 'header_static_text_title',
  HT: 'header_title_text',
  HTD: 'history_thumbs_down',
  HTT: 'history_track_title',
  HTU: 'history_thumbs_up',
  HVSB: 'hover_view_stations_button',
  KAB: 'keep_account_button',
  KLB: 'keep_listening_button',
  KMLB: 'keepme_loggedin_button',
  LB: 'login_button',
  LOADB: 'log_out_all_devices_button',
  LSLB: 'lyrics_show_less_button',
  LSMB: 'lyrics_show_more_button',
  MB: 'message_bar',
  MCALB: 'my_collection_albums_link',
  MCALL: 'my_collection_all_link',
  MCALPHAO: 'my_collection_alpha_option',
  MCART: 'my_collection_artists_link',
  MCBB: 'mini_coachmark_browse_button',
  MCCB: 'mini_coachmark_close_button',
  MCDC: 'modal_coachmark_dialog_close',
  MCDCTA: 'modal_coachmark_dialog_cta',
  MCEMPTY: 'my_collection_empty_state',
  MCMT: 'mini_coachmark_message_text',
  MCNPB: 'my_collection_new_playlist_button',
  MCPC: 'my_collection_podcasts_link',
  MCPE: 'my_collection_episodes_link',
  MCPL: 'my_collection_playlists_link',
  MCRAO: 'my_collection_recent_added_option',
  MCSDD: 'my_collection_sort_dropdown',
  MCSONG: 'my_collection_songs_link',
  MCST: 'my_collection_stations_link',
  MCTT: 'mini_coachmark_title_text',
  MLIIL: 'media_list_item_itunes_logo',
  MONTHLYPLAN: 'monthly_plan',
  MTAN: 'mini_track_artist_name',
  MTI: 'mini_track_image',
  MTT: 'mini_track_title',
  NB: 'no_button',
  NNB: 'not_now_button',
  NPSLRS: 'now_playing_station_list_recommended_station',
  NPSLS: 'now_playing_station_list_station',
  NPT3CT: 'now_playing_t3_current_track',
  NPT3RP: 'now_playing_t3_row_item_play_button',
  NPT3RT: 'now_playing_t3_row_item_text',
  OB: 'ok_button',
  PALN: 'playing_album_name',
  PAN: 'playing_artist_name',
  PB: 'profile_bio',
  PCM: 'profile_community_menu',
  PEB: 'profile_edit_bio',
  PECB: 'profile_edit_cancel_button',
  PEE: 'profile_edit_employer',
  PEL: 'profile_edit_link',
  PELO: 'profile_edit_location',
  PEN: 'profile_edit_name',
  PES: 'profile_edit_school',
  PESB: 'profile_edit_save_button',
  PESL: 'profile_edit_settings_link',
  PFM: 'profile_feed_menu',
  PHM: 'profile_help_menu',
  PI: 'password_input',
  PLAYPAUSE: ['play_button', 'pause_button'],
  PM: 'popup_message',
  PMPM: 'profile_myprofile_menu',
  PN: 'profile_name',
  PPS: 'profile_privacy_status',
  PSB: 'paypal_submit_button',
  PSCA: 'payment_submit_checkbox_agreeToTerms',
  PSCCTB: 'payment_submit_credit_card_toggle_button',
  PSL: 'password_show_link',
  PSM: 'profile_settings_menu',
  PSMFORB: 'payment_submit_monthly_frequency_option_radio_button',
  PSOM: 'profile_signout_menu',
  PSPTB: 'payment_submit_paypal_toggle_button',
  PSSOTL: 'payment_submit_subscription_offer_terms_link',
  PSSRAR: 'payment_subscription_student_reverification_auto_renew',
  PSSRRNW: 'payment_subscription_student_reverification_renewal',
  PSSTL: 'payment_submit_subscription_terms_link',
  PST: 'popup_sub_title',
  PSYFORB: 'payment_submit_yearly_frequency_option_radio_button',
  PT: 'popup_title',
  PTT: 'playing_track_title',
  PULMLB: 'popup_let_me_listen_button',
  PULTLB: 'popup_let_them_listen_button',
  PUMI: 'popup_main_image',
  PUMT: 'popup_message_text',
  PUTT: 'popup_title_text',
  RB: 'replay_button',
  RI: 'row_item',
  RMB: 'read_more_button',
  RPA: 'radial_progress_animation',
  RT: 'remaining_time',
  S: 'search',
  SAE: 'station_active_equalizer',
  SAI: 'station_active_image',
  SAID: 'station_active_image_default',
  SAN: 'station_active_name',
  SB: 'skip_button',
  SCAC: 'source_card_add_collection',
  SCAP: 'source_card_add_playlist',
  SCDP: 'source_card_delete_playlist',
  SCDS: 'source_card_delete_station',
  SCES: 'source_card_edit_station',
  SCNP: 'source_card_new_playlist',
  SCRC: 'source_card_remove_collection',
  SCRP: 'source_card_remove_track_from_playlist',
  SCS: 'source_card_share',
  SCSSA: 'source_card_start_station_artist',
  SCSST: 'source_card_start_station_track',
  SCTOT: 'source_card_tired_of_track',
  SCWTS: 'source_card_why_this_song',
  SEA: 'station_see_all',
  SFC: 'search_field_clear',
  SFP: 'search_field_placeholder',
  SHQA: 'settings_high_quality_audio',
  SHT: 'sub_header_text',
  SI: 'station_image',
  SID: 'station_image_default',
  SIMAI: 'similar_artist_image',
  SIMAIT: 'similar_artist_item',
  SIMAN: 'similar_artist_name',
  SLITFL: 'search_list_item_text_first_line',
  SLS: 'station_listen_status',
  SMBMT: 'share_modal_body_main_text',
  SMBRMT: 'share_modal_btm_row_main_text',
  SMHE: 'share_modal_header_email',
  SMSB: 'share_modal_share_button',
  SMSBF: 'share_modal_social_button_facebook',
  SMSBT: 'share_modal_social_button_twitter',
  SNL: 'station_name_link',
  SNLI: 'station_name_listener',
  SNR: 'station_name_recomended',
  SP: 'sample_player',
  SPANNUAL: 'switch_plans_annual',
  SPCANCEL: 'switch_plans_cancel',
  SPCONTINUE: 'switch_plans_continue',
  SPLINK: 'switch_plans_link',
  SPMONTHLY: 'switch_plans_monthly',
  SPSWITCH: 'switch_plans_switch',
  SRB: 'settings_redeem_button',
  SRLI: 'search_results_list_item',
  SRT: 'search_results_title',
  STI: 'station_tile_image',
  SUB: 'signup_button',
  SUBB: 'submit_button',
  T3SBB: 't3_skip_back_button',
  T3SFB: 't3_skip_forward_button',
  TANL: 'track_artist_name_link',
  TB: 'tuner_bar',
  TDB: 'thumbs_down_button',
  TIERSETTINGS: 'tier_settings',
  TMCS: 'track_menu_create_station',
  TNL: 'track_name_link',
  TOMB: 'track_open_menu_button',
  TRB: 'tuner_repeat_button',
  TSB: 'tuner_shuffle_button',
  TSNL: 'track_station_name_link',
  TTI: 'track_thumbnail_image',
  TUB: 'thumbs_up_button',
  TUL: 'thumbs_up_link',
  URSB: 'undo_remove_station_button',
  VAN: 'vt_artist_name',
  VCB: 'vt_cta_button',
  VHAN: 'vt_history_artist_name',
  VHCB: 'vt_history_cta_button',
  VI: 'volume_icon',
  VS: 'volume_slider',
  VSH: 'volume_slider_handle',
  WAB: 'why_ads_button',
  YB: 'yes_button',
  YEARLYPLAN: 'yearly_plan',
  YPL: 'your_profile_link',
  ZI: 'zipcode_input',
  ZYL: 'zipcode_why_link',

  // todo: WEBCLIENT-7380: technical decision on whether to modularize QATags
  // Modals
  MDPC: 'modal_delete_playlist_confirm',

  // Footer.jsx
  F: 'footer',
  SUCTA: 'footer_signup_cta_button',
  SUM: 'footer_signup_message',

  // InfoCardC.jsx
  ICC: 'info_card_chevron',

  // UpgradeSplashDevice.jsx
  USDC: 'upgrade_splash_device_cta',
  USDI: 'upgrade_splash_device_image',

  // UpgradeLayout.jsx
  ULH: 'upgrade_layout_header',
  ULS: 'upgrade_layout_subheader',
  ULTOTL: 'upgrade_layout_trial_offer_terms_link', // trial offer terms link

  // UpgradeCard.jsx
  UC: 'upgrade_card', // (variation will be appended)
  UCC: 'upgrade_card_cta_button', // cta
  UCCL: 'upgrade_card_content_list',
  UCCLPFML: 'upgrade_card_content_list_premium_features_modal_link',
  UCFT: 'upgrade_card_footer_text', // footer text
  UCPLL: 'upgrade_card_link', // pipedLinks link (variation will be appended)
  UCPLT: 'upgrade_card_links_title', // pipedLinks title
  UCPT: 'upgrade_card_product_text', // primary text
  UCST: 'upgrade_card_pricing_text', // secondary text

  // AuthLayout.jsx
  AL: 'auth_layout', // (page variation will be appended)

  /* QA tags for Skips/Replays coachmarks, which are hosted in haymaker:
   *   'coachmark_main_image',
   *   'coachmark_title_text',
   *   'coachmark_message_text',
   *   'coachmark_get_skips_button',
   *   'coachmark_get_replays_button',
   *   'coachmark_not_now_button'
   */
} as const);

export default QATags;
